import { FC } from 'react';
import Image from 'next/image';

import { classNames } from 'common/utils/classNames';
import { ImageThumbnailProps } from 'composables/Product/Buy/ImageSlider/ImageSlider';

import styles from './ImageSlider.module.scss';

export const ImageThumbnail: FC<ImageThumbnailProps> = ({ src, alt, selected }) => {
  return (
    <div
      className={classNames(
        'bg-black bg-opacity-8 outline-2 outline-focus group-focus-visible/slider-thumbnail:outline dark:bg-opacity-24',
        styles.smallThumb,
        selected && 'border border-yellow'
      )}
    >
      <Image
        className="h-[3rem] w-[3rem] object-contain"
        src={`https:${src}`}
        alt={alt}
        width={200}
        height={200}
      />
    </div>
  );
};
